// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34Ghn","colBig":"styles_colBig__1wZCS","colSmall":"styles_colSmall__3I_ik"};